import styled from 'styled-components'

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  margin-top: 6rem;

  h3 {
    font-size: var(--font-large);
    margin-top: 40px;
  }

  p {
    font-size: var(--font-small);
    color: var(--color4);
    margin-top: 24px;
  }
`
